
    <div class="page-listing">
      <header-menu></header-menu>
      <search-container *ngIf="(user$ | async)?.typeBusiness === 'company'"></search-container>
      <component-filters *ngIf="(user$ | async)?.typeBusiness !== 'company'"></component-filters>
    </div>
  